// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Music } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconMusic(props: any) {
    return <IconBase icon={Music} {...props} />
  }

  export default IconMusic
  